/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strong_Bold_Hawk_LabelInputs */

const en_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New email address`)
};

const id_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email baru`)
};

const ms_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat e-mel baru`)
};

const ca_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova adreça de correu electrònic`)
};

const cs_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová e-mailová adresa`)
};

const da_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny e-mailadresse`)
};

const de_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue E-Mail-Adresse`)
};

const et_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uus e-posti aadress`)
};

const es_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo correo electrónico`)
};

const fr_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle adresse e-mail`)
};

const hr_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova e-mail adresa`)
};

const it_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo indirizzo email`)
};

const lv_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauna e-pasta adrese`)
};

const lt_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naujas el. pašto adresas`)
};

const hu_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új e-mail cím`)
};

const nl_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw e-mailadres`)
};

const nb_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny e-postadresse`)
};

const pl_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowy adres e-mail`)
};

const pt_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo endereço de e-mail`)
};

const ro_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noua adresă de e-mail`)
};

const sk_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová emailová adresa`)
};

const sl_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novi e-naslov`)
};

const fi_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi sähköpostiosoite`)
};

const sv_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny e-postadress`)
};

const vi_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email mới`)
};

const tr_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni e-posta adresi`)
};

const el_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νέα διεύθυνση email`)
};

const bg_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нов имейл адрес`)
};

const ru_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый адрес электронной почты`)
};

const sr_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нова имејл адреса`)
};

const uk_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нова адреса електронної пошти`)
};

const ka_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ახალი ელექტრონული ფოსტის მისამართი`)
};

const hi_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया ईमेल एड्रेस`)
};

const th_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมลใหม่`)
};

const ko_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 이메일 주소`)
};

const zh_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新电子邮件地址`)
};

const zh_tw_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新電子郵件地址`)
};

const ja_strong_bold_hawk_label = /** @type {(inputs: Strong_Bold_Hawk_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいメールアドレス`)
};

/**
* | output |
* | --- |
* | "New email address" |
*
* @param {Strong_Bold_Hawk_LabelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const strong_bold_hawk_label = /** @type {((inputs?: Strong_Bold_Hawk_LabelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strong_Bold_Hawk_LabelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_strong_bold_hawk_label(inputs)
	if (locale === "ms") return ms_strong_bold_hawk_label(inputs)
	if (locale === "ca") return ca_strong_bold_hawk_label(inputs)
	if (locale === "cs") return cs_strong_bold_hawk_label(inputs)
	if (locale === "da") return da_strong_bold_hawk_label(inputs)
	if (locale === "de") return de_strong_bold_hawk_label(inputs)
	if (locale === "et") return et_strong_bold_hawk_label(inputs)
	if (locale === "es") return es_strong_bold_hawk_label(inputs)
	if (locale === "fr") return fr_strong_bold_hawk_label(inputs)
	if (locale === "hr") return hr_strong_bold_hawk_label(inputs)
	if (locale === "it") return it_strong_bold_hawk_label(inputs)
	if (locale === "lv") return lv_strong_bold_hawk_label(inputs)
	if (locale === "lt") return lt_strong_bold_hawk_label(inputs)
	if (locale === "hu") return hu_strong_bold_hawk_label(inputs)
	if (locale === "nl") return nl_strong_bold_hawk_label(inputs)
	if (locale === "nb") return nb_strong_bold_hawk_label(inputs)
	if (locale === "pl") return pl_strong_bold_hawk_label(inputs)
	if (locale === "pt") return pt_strong_bold_hawk_label(inputs)
	if (locale === "ro") return ro_strong_bold_hawk_label(inputs)
	if (locale === "sk") return sk_strong_bold_hawk_label(inputs)
	if (locale === "sl") return sl_strong_bold_hawk_label(inputs)
	if (locale === "fi") return fi_strong_bold_hawk_label(inputs)
	if (locale === "sv") return sv_strong_bold_hawk_label(inputs)
	if (locale === "vi") return vi_strong_bold_hawk_label(inputs)
	if (locale === "tr") return tr_strong_bold_hawk_label(inputs)
	if (locale === "el") return el_strong_bold_hawk_label(inputs)
	if (locale === "bg") return bg_strong_bold_hawk_label(inputs)
	if (locale === "ru") return ru_strong_bold_hawk_label(inputs)
	if (locale === "sr") return sr_strong_bold_hawk_label(inputs)
	if (locale === "uk") return uk_strong_bold_hawk_label(inputs)
	if (locale === "ka") return ka_strong_bold_hawk_label(inputs)
	if (locale === "hi") return hi_strong_bold_hawk_label(inputs)
	if (locale === "th") return th_strong_bold_hawk_label(inputs)
	if (locale === "ko") return ko_strong_bold_hawk_label(inputs)
	if (locale === "zh") return zh_strong_bold_hawk_label(inputs)
	if (locale === "zh-tw") return zh_tw_strong_bold_hawk_label(inputs)
	if (locale === "ja") return ja_strong_bold_hawk_label(inputs)
	return en_strong_bold_hawk_label(inputs)
});